export enum MONITORING_EVENT_BUS_EVENTS {
  REFRESH_EVENTS = "MONITORING_EVENT_BUS_EVENTS.REFRESH_EVENTS",
  REFRESH_EVENTS_FINISH = "MONITORING_EVENT_BUS_EVENTS.REFRESH_EVENTS_FINISH",
  ADD_NEW_EVENT = "MONITORING_EVENT_BUS_EVENTS.ADD_NEW_EVENT",
}
